import React, { useState } from 'react';
import NewModal from '../../../../../Shared/NewModal';
import { Tab, Tabs, Box } from '@mui/material';
import { HubHistoryDetails } from './HubHistoryDetails';
import { HubHistoryNotes } from './HubHistoryNotes';
import { DeviceHistoryItem } from '../../../../../../store/devices/deviceTypes';
import { dimGrey, lightBlack, lightTeal } from '../../../../../../mainTheme';

const tabStyles = {
  indicator: {
    backgroundColor: lightTeal,
  },
  tab: {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    color: dimGrey,
    lineHeight: '20px',
    letterSpacing: '0.24px',
  },
  selected: {
    color: `${lightBlack} !important`,
  },
};

interface HubHistoryDetailModalProps {
  onClose: () => void;
  rowData: DeviceHistoryItem | null;
  selectedDeviceId: number | undefined;
}

const HubHistoryDetailModal: React.FC<HubHistoryDetailModalProps> = ({
  onClose,
  rowData,
  selectedDeviceId,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <NewModal
      showCloseX
      title="Hub history"
      onClose={onClose}
      maxWidth="sm"
      contentPaddingTop="0px"
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTabs-indicator': tabStyles.indicator,
          '& .MuiTab-root': tabStyles.tab,
          '& .Mui-selected': tabStyles.selected,
        }}
      >
        <Tab label="Details" />
        <Tab label="Notes" />
      </Tabs>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} />
      {activeTab === 0 ? (
        <HubHistoryDetails rowData={rowData} />
      ) : (
        <HubHistoryNotes
          rowData={rowData}
          selectedDeviceId={selectedDeviceId || 0}
        />
      )}
    </NewModal>
  );
};

export default HubHistoryDetailModal;
